if (!customElements.get('SubscriptionVariantSelects')) {
    /**
     *  @class
     *  @function SubscriptionVariantSelects
     */
    class SubscriptionVariantSelects extends HTMLElement {
      constructor() {
        super();
        this.sticky = this.dataset.sticky;
        this.updateUrl = this.dataset.updateUrl === 'true';
        this.isDisabledFeature = this.dataset.isDisabled;
        this.addEventListener('change', this.onVariantChange);
        this.other = Array.from(document.querySelectorAll('subscription-variant-selects')).filter((selector) => {
          return selector != this;
        });

        this.productWrapper = this.closest('.thb-product-detail');
        this.productSlider = this.productWrapper.querySelector('.product-images');
        this.hideVariants = this.dataset.hideVariants === 'true';
      }

      connectedCallback() {
        this.updateOptions();
        this.updateMasterId();
        this.setDisabled();
        this.setImageSet();
        this.hideUnrelatedVariants();
        this.formatVariantLabels();
        this.handleDiaperCount();
        this.renderProductInfo();

        //fix calendar onLoad date
        const now = new Date();
        const inputValue = now.toLocaleDateString('fr-fr');
        const dateInput = document.querySelector('#calendar-input');
  
        if (dateInput) {
          dateInput.value = inputValue;
        }
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        // this.updateVariantText();
        this.setDisabled();
        this.hideUnrelatedVariants();
        this.handleDiaperCount();

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          if (this.updateUrl) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          //this.updateShareUrl();
        }

        this.updateOther();
        dispatchCustomEvent('product:variant-change', {
          variant: this.currentVariant,
          sectionId: this.dataset.section
        });
      }

      updateOptions() {
        this.fieldsets = Array.from(this.querySelectorAll('fieldset:not(.selling__plan)'));
        this.options = [];

        this.fieldsets.forEach((fieldset, i) => {
          if (fieldset.querySelector('select')) {
            this.options.push(fieldset.querySelector('select').value);
          } else if (fieldset.querySelectorAll('input').length) {
            this.options.push(fieldset.querySelector('input:checked').value);
          }
        });
        
        const valid_variants = this.getVariantData().filter((variant) => {
          return this.options[0] === variant.option1;
        });
        let is_valide = false;
        
        valid_variants.forEach(variant => {
          (variant.option2 === this.options[1]) && (is_valide = true);
        });
        
        if (!is_valide) {
          const newCurrentVariant = this.getVariantData().find((variant) => {
            return this.options[0] === variant.option1;
          });
          
          if (newCurrentVariant) {
            this.options[0] = newCurrentVariant.option1;
            this.options[1] = newCurrentVariant.option2;
          }
        }
      }

      formatVariantLabels() {
        const optionLabels = document.querySelectorAll('subscription-variant-selects fieldset[data-index="option2"] .label__value');

        if (optionLabels.length > 0) {
          optionLabels.forEach((label) => {
            const labelText = label.innerHTML;

            if (labelText.includes(') –')) {
              let firstSpan = document.createElement('span');
              let secondSpan = document.createElement('span');
              const splitedText = labelText.split(') –');
              firstSpan.innerHTML = splitedText['0'] + ')';
              secondSpan.innerHTML = splitedText['1'];
              label.innerHTML = '';
              label.append(firstSpan);
              label.append(secondSpan);
            }
          });
        }
      }

      hideUnrelatedVariants() {
        const currentType = this.currentVariant.options[0].toLowerCase();
        const sizeInputs = document.querySelectorAll('subscription-variant-selects fieldset[data-index="option2"] input');
        const typeSelected = document.querySelectorAll('subscription-variant-selects fieldset[data-index="option1"] input');
  
        sizeInputs.forEach((input) => {
          if (currentType.includes('&')) {
            if (!input.value.includes(' + ')) {
              document.querySelector('label[for="' + input.id + '"]').style.display = 'none';
            } else {
              document.querySelector('label[for="' + input.id + '"]').style.display = 'inline-flex';
            }
          } else {
            if (!input.value.toLowerCase().includes(currentType)) {
              document.querySelector('label[for="' + input.id + '"]').style.display = 'none';
            } else {
              document.querySelector('label[for="' + input.id + '"]').style.display = 'inline-flex';
            }
  
            if (input.value.includes('x ')) {
              document.querySelector('label[for="' + input.id + '"]').style.display = 'none';
            }
          }
        });
        const selectedInput = document.querySelector('subscription-variant-selects fieldset[data-index="option2"] input:checked');
        const selecctedLabel =  document.querySelector('label[for="' + selectedInput.id + '"]');
  
        if (selecctedLabel.style.display === 'none') {
          const firstVisibleVariant = Array.from(sizeInputs).find(input => document.querySelector('subscription-variant-selects fieldset[data-index="option2"] label[for="' + input.id + '"]').style.display == 'inline-flex');
          const firstVisibleLabel = document.querySelector('label[for="' + firstVisibleVariant.id + '"]');
  
          if (firstVisibleLabel) {
            firstVisibleLabel.click();
          }
        }
      }

      handleDiaperCount() {
        const diaperCountEl = document.querySelector('.selling__plan .diaper_count');
        const variantMetafields = this.getVariantMetafields();

        if (diaperCountEl) {
          const diaperCount = variantMetafields[this.currentVariant.id];

          if (!diaperCount) {
            diaperCountEl.style.display = 'none'
          } else {
            diaperCountEl.style.display = 'block'
          }
          const selectedlabel = document.querySelector('subscription-variant-selects .selling__plan input:checked+label');

          if (selectedlabel && diaperCount) {
            const frequency = selectedlabel.textContent.match(/(\d+)/);
            
            if (frequency) {
              const diaperCountPerDay = parseInt(diaperCount) / (parseInt(frequency) * 7);
              const diaperCountElSpan = diaperCountEl.querySelector('span');

              if (diaperCountElSpan) {
                diaperCountElSpan.innerHTML = this.roundToDecimalPlaces(diaperCountPerDay, 1);
              }
            }
          }
        }
      }

      roundToDecimalPlaces(num, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(num * factor) / factor;
      }

      updateVariantText() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        fieldsets.forEach((item, i) => {
          let label = item.querySelector('.form__label__value');
          if (label) {
            label.innerHTML = this.options[i];
          }
        });
      }
      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
      }

      updateOther() {
        if (this.dataset.updateUrl === 'false') {
          return;
        }
        if (this.other.length) {
          let fieldsets = this.other[0].querySelectorAll('fieldset'),
            fieldsets_array = Array.from(fieldsets);
          this.options.forEach((option, i) => {
            if (fieldsets_array[i].querySelector('select')) {
              fieldsets_array[i].querySelector(`select`).value = option;
            } else if (fieldsets_array[i].querySelectorAll('input').length) {
              fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
            }
          });
          this.other[0].updateOptions();
          this.other[0].updateMasterId();
          // this.other[0].updateVariantText();
          this.other[0].setDisabled();
        }
      }

      updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        let productSlider = document.querySelector('.thb-product-detail .product-images'),
          thumbnails = document.querySelector('.thb-product-detail #Product-Thumbnails');

        this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, productSlider, thumbnails);
      }
      setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
        let flkty = Flickity.data(productSlider),
          activeMedia = productSlider.querySelector(mediaId);

        if (flkty && this.hideVariants) {


          if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
            productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeMedia.classList.add('is-active');
          activeMedia.classList.add('is-initial-selected');

          this.setImageSetMedia();

          if (thumbnails) {
            let activeThumb = thumbnails.querySelector(thumbId);

            if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
              thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
            }
            [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
              el.classList.remove('is-active');
            });

            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }

          productSlider.reInit(this.imageSetIndex);
          productSlider.selectCell(mediaId);

        } else if (flkty) {
          productSlider.selectCell(mediaId);
        }

      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      }

      updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute('available');
          pickUpAvailability.innerHTML = '';
        }
      }

      removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
      }

      getSectionsToRender() {
        return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
      }

      renderProductInfo() {
        let sections = this.getSectionsToRender();

        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            sections.forEach((id) => {
              const destination = document.getElementById(id);
              const source = html.getElementById(id);

              if (source && destination) destination.innerHTML = source.innerHTML;

              const price = document.getElementById(id);
              const price_fixed = document.getElementById(id + '--sticky');

              if (price) price.classList.remove('visibility-hidden');
              if (price_fixed) price_fixed.classList.remove('visibility-hidden');

            });
            this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

          });
      }

      toggleAddButton(disable = true, text = false, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;

        const productTemplate = productForm.getAttribute('template');
        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

        if (!submitButtons) return;
        submitButtons.forEach((submitButton) => {
          const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

          if (!submitButtonText) return;

          if (disable) {
            submitButton.setAttribute('disabled', 'disabled');
            if (text) submitButtonText.textContent = text;
          } else {
            submitButton.removeAttribute('disabled');
            submitButton.classList.remove('loading');

            if (productTemplate?.includes('pre-order')) {
              submitButtonText.textContent = window.theme.variantStrings.preOrder;
            } else {
              submitButtonText.textContent = window.theme.variantStrings.addToCart;
            }
          }
        });

        if (!modifyClass) return;
      }

      setUnavailable() {
        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

        submitButtons.forEach((submitButton) => {
          const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
          if (!submitButton) return;
          submitButtonText.textContent = window.theme.variantStrings.unavailable;
          submitButton.classList.add('sold-out');
        });
        if (price) price.classList.add('visibility-hidden');
        if (price_fixed) price_fixed.classList.add('visibility-hidden');
      }

      setDisabled() {
        if (this.isDisabledFeature != 'true') {
          return;
        }
        const variant_data = this.getVariantData();

        if (variant_data) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          this.fieldsets.forEach((fieldset, i) => {
            const fieldset_options = Object.values(available_options)[i];

            if (fieldset_options) {
              if (fieldset.querySelector('select')) {
                fieldset_options.forEach((option, option_i) => {
                  if (option.isUnavailable) {
                    fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                  } else {
                    fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                  }
                });
              } else if (fieldset.querySelectorAll('input').length) {
                fieldset.querySelectorAll('input').forEach((input, input_i) => {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                });
              }
            }
          });

        }
        return true;
      }

      getImageSetName(variant_name) {
        return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      }

      setImageSet() {
        if (!this.productSlider) return;

        let dataSetEl = this.productSlider.querySelector('[data-set-name]');
        if (dataSetEl) {
          this.imageSetName = dataSetEl.dataset.setName;
          this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
          this.dataset.imageSetIndex = this.imageSetIndex;
          this.setImageSetMedia();
        }
      }
      setImageSetMedia() {
        if (!this.imageSetIndex) {
          return;
        }

        let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
        let group = this.imageSetName + '_' + setValue;
        let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
          selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

        if (this.hideVariants) {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          // Product thumbnails
          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        }

      }

      createAvailableOptionsTree(variant_data, selected_options) {
        // Reduce variant array into option availability tree
        return variant_data.reduce((options, variant) => {

          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {

            if (variant[index] === null) return;

            let entry = options[index].find(option => option.value === variant[index]);

            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
              value,
              index
            }) => {
              return variant[index] === value ? count + 1 : count;
            }, 0);

            // Only enable an option if an available variant matches all but one current selected value
            if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === 'option1') {
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
            }
          });

          return options;
        }, {
          option1: [],
          option2: [],
          option3: []
        });
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('#product-variants').textContent);
        return this.variantData;
      }

      getVariantMetafields() {
        this.variantMetafields = this.variantMetafields || JSON.parse(this.querySelector('#variant-meta').textContent);
        return this.variantMetafields;
      }
    }
    customElements.define('subscription-variant-selects', SubscriptionVariantSelects);
}

if (!customElements.get('SubscriptionRecap')) {
  /**
   *  @class
   *  @function SubscriptionRecap
   */
  class SubscriptionRecap extends HTMLElement {
    constructor() {
      super();
      this.quantitySelectors = document.querySelectorAll('.optional__products quantity-selector input');
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.updateSummary();
      // this.stickyObserver();
      document.addEventListener("product:variant-change", this.onVariantChange.bind(this));
      
      if (this.quantitySelectors.length > 0) {
        this.quantitySelectors.forEach(selector => {
          selector.addEventListener("change", this.onOtherProductsQuantityChange.bind(this));
        });
      }
    }

    /**
     * TODO: make sticky stop when scrolled to footer
     */
    stickyObserver() {
      let stickyAnchor = document.querySelector('#js-recap-sticky');

      if (stickyAnchor) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              this.classList.add('-sticky');
            } else {
              this.classList.remove('-sticky');
            }
          })
        })
        observer.observe(stickyAnchor);
      }
    }

    onVariantChange(event) {
      this.updatePrice(event.detail.variant.price);
      this.updateOptions();
      this.updateMasterId();
      this.updateSummary();
    }

    updatePrice(price) {
      this.dataset.totalPrice = price;
    }

    onOtherProductsQuantityChange() {
      const optionalVariantIds = Array.from(this.quantitySelectors).filter(input => input.value > 0)
        .map(variant => {
          const oneTimeEl = variant.parentElement.parentElement.querySelector('.one-time input');
          let oneTime = true;

          if (oneTimeEl) {
            oneTime = oneTimeEl.checked;
          }

          return {
            title: variant.dataset.variantTitle,
            price: parseInt(variant.dataset.productPrice) * parseInt(variant.value),
            quantity: parseInt(variant.value),
            oneTime: oneTime
          };
      });
      let otherProductsTotalPrice = 0;

      if (optionalVariantIds.length === 0) {
        this.querySelector('.recap_other_products').innerHTML = '';
        this.dataset.otherProductPrice = 0;
        this.updateSummary();
        
        return;
      }

      if (this.querySelector('.recap_other_products') && optionalVariantIds.length > 0) {
        this.querySelector('.recap_other_products').innerHTML = '';
        let ulElement = document.createElement('ul');
        optionalVariantIds.forEach(variant => {
          let listElement = document.createElement('li');
          let listElementContent = `+ ${variant.title}`;
          
          if (variant.quantity > 0) {
            listElementContent = listElementContent.concat(' x ', variant.quantity);
            otherProductsTotalPrice = otherProductsTotalPrice + variant.price;
          }
          const oneTimeMessage = document.querySelector('.optional__products');

          if (variant.oneTime && oneTimeMessage) {
            listElementContent += ` <span>${oneTimeMessage.dataset.oneTime}</span>`;
          }
          listElement.innerHTML = listElementContent;
          ulElement.append(listElement);
        });
        this.querySelector('.recap_other_products').append(ulElement);
      } else {
        this.querySelector('.recap_other_products').innerHTML = '';
      }

      if (otherProductsTotalPrice > 0) {
        this.dataset.otherProductPrice = otherProductsTotalPrice;
      }

      this.updateSummary();
    }

    updateSummary() {
      const totalPrice = parseFloat(this.dataset.totalPrice);
      const otherProductPrice = parseFloat(this.dataset.otherProductPrice);

      if (this.querySelector('.recap_total .price')) {
        this.querySelector('.recap_total .price').innerHTML = this.formatPrice(totalPrice + otherProductPrice);
      }

      if (this.querySelector('.js_recap_type')) {
        this.querySelector('.js_recap_type').innerHTML = this.currentVariant.options[0];
      }

      if (this.querySelector('.js_recap_size')) {
        this.querySelector('.js_recap_size').innerHTML = this.currentVariant.options[1];
      }
      const currentPlan = document.querySelector('subscription-variant-selects fieldset.selling__plan input:checked');

      if (currentPlan) {
        this.querySelector('.js_recap_frequency').innerHTML = currentPlan.dataset.optionName;
      }
    }

    formatPrice(price) {
      const formated = parseInt(price) / 100;
      return `${Shopify.currency.active} ${formated.toFixed(2)}`;
    }

    updateOptions() {
      this.fieldsets = Array.from(document.querySelectorAll('subscription-variant-selects fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(document.querySelector('#product-variants').textContent);
      return this.variantData;
    }
  }
  customElements.define('subscription-recap', SubscriptionRecap);
}